import React from 'react';
import { Link } from 'react-router-dom';

const Collections = () => {
  const collections = [
    {
      id: 1,
      name: 'Hand Tufted Rugs',
      shortName: 'Hand Tufted Rugs',
      description: 'Modern textures · Wool & Silk · Custom Designs',
      slug: 'hand-tufted',
      image: '/images/image.png',
      fallbackImage: 'https://images.unsplash.com/photo-1600166898405-da9535204843?w=1200&h=1600&fit=crop'
    },
    {
      id: 2,
      name: 'Hand Knotted Rugs',
      shortName: 'Hand Knotted Rugs',
      description: 'Timeless craftsmanship · Heirloom quality.',
      slug: 'hand-knotted',
      image: '/images/image2.png',
      fallbackImage: 'https://images.unsplash.com/photo-1616486338812-3dadae4b4ace?w=1200&h=1600&fit=crop'
    }
  ];

  return (
    <section
      id="products"
      className="bg-gradient-to-b from-white via-gray-50 to-white scroll-mt-20 md:scroll-mt-24 min-h-[calc(100vh-80px)] md:min-h-[calc(100vh-96px)] py-10 md:py-12"
    >
      <div className="container mx-auto px-6 w-full">
        <div className="text-center mb-6 sm:mb-8 md:mb-8 flex-shrink-0 px-4">
          <h2 className="text-3xl sm:text-4xl md:text-5xl font-extrabold text-gray-900 mb-3 sm:mb-4" style={{fontFamily: "'Playfair Display', 'Georgia', serif"}}>
            Our Rug Collections
          </h2>
          <p className="text-base sm:text-lg md:text-xl text-gray-600 max-w-2xl mx-auto leading-relaxed mb-4 sm:mb-6">
            Wovn Rugss (wovnrugss.com) — Woven rugs, wovn rugs, wovnrugs, wovenrugs. Handcrafted rugs and carpets made using traditional techniques and quality materials. <Link to="/hand-tufted-rugs" className="text-amber-600 hover:text-amber-700 font-semibold underline">Explore our Hand Tufted Collection</Link>, <Link to="/hand-knotted-rugs" className="text-amber-600 hover:text-amber-700 font-semibold underline">browse hand knotted rugs</Link>, or <Link to="/#contact" className="text-amber-600 hover:text-amber-700 font-semibold underline">view custom rug options</Link>.
          </p>
          <button
            onClick={() => {
              window.location.href = '#contact';
            }}
            className="inline-flex items-center justify-center gap-2 sm:gap-3 px-8 sm:px-12 md:px-16 lg:px-24 xl:px-32 py-3 sm:py-4 md:py-5 bg-gradient-to-r from-amber-600 to-orange-600 text-white rounded-full text-sm sm:text-base md:text-lg lg:text-xl font-bold hover:from-amber-700 hover:to-orange-700 transition-all transform hover:scale-105 shadow-xl hover:shadow-amber-500/50 group w-full sm:w-auto sm:min-w-[280px] md:min-w-[350px] lg:min-w-[450px]"
          >
            <span>Our Latest Catalogue</span>
            <svg className="w-5 h-5 md:w-6 md:h-6 transform group-hover:translate-x-1 transition-transform" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M10 6H6a2 2 0 00-2 2v10a2 2 0 002 2h10a2 2 0 002-2v-4M14 4h6m0 0v6m0-6L10 14" />
            </svg>
          </button>
        </div>

        {/* Collections Grid - Equal sized cards */}
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-3 sm:gap-4 md:gap-6">
          {collections.map((collection) => (
            <Link
              key={collection.id}
              to={collection.slug === 'hand-tufted' ? '/hand-tufted-rugs' : '/hand-knotted-rugs'}
              className="group relative h-[280px] sm:h-[360px] lg:h-[420px] xl:h-[480px] rounded-2xl overflow-hidden shadow-2xl transform transition-all duration-500 hover:scale-[1.02] text-left w-full block"
            >
              <img 
                src={collection.image} 
                alt={collection.slug === 'hand-tufted' ? 'Modern hand tufted rug collection by Wovn Rugss – wovnrugss.com' : 'Luxury hand knotted rug collection by Wovn Rugss – wovnrugss.com'}
                className="w-full h-full object-cover object-center transition-transform duration-500 group-hover:scale-105"
                loading="lazy"
                onError={(e) => {
                  e.target.src = collection.fallbackImage;
                }}
              />
              
              {/* Hover Overlay - Bottom Section with Info */}
              <div className="absolute bottom-0 left-0 right-0 h-[40%] bg-black/70 backdrop-blur-sm transition-all duration-700 ease-[cubic-bezier(0.4,0,0.2,1)] transform translate-y-full group-hover:translate-y-0 opacity-0 group-hover:opacity-100">
                <div className="p-4 sm:p-6 md:p-8 h-full flex flex-col justify-center">
                  <h3 className="text-white text-xl sm:text-2xl md:text-3xl font-bold mb-2 text-left transform transition-all duration-500 delay-75 ease-out translate-y-4 opacity-0 group-hover:translate-y-0 group-hover:opacity-100">
                    {collection.shortName}
                  </h3>
                  <p className="text-white text-xs sm:text-sm md:text-base mb-3 sm:mb-4 text-left transform transition-all duration-500 delay-150 ease-out translate-y-4 opacity-0 group-hover:translate-y-0 group-hover:opacity-90">
                    {collection.description}
                  </p>
                  <div className="inline-block transform transition-all duration-500 delay-200 ease-out translate-y-4 opacity-0 group-hover:translate-y-0 group-hover:opacity-100">
                    <span className="inline-flex items-center gap-2 px-4 sm:px-6 py-2 sm:py-3 border-2 border-white text-white rounded-lg font-semibold text-xs sm:text-sm md:text-base hover:bg-white hover:text-black transition-all duration-300 cursor-pointer">
                      {collection.slug === 'hand-tufted' ? 'Explore Hand Tufted Collection' : 'Explore Hand Knotted Rugs'}
                      <svg className="w-3 h-3 sm:w-4 sm:h-4 md:w-5 md:h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 7l5 5m0 0l-5 5m5-5H6" />
                      </svg>
                    </span>
                  </div>
                </div>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Collections;

